module.exports = __webpack_public_path__ + "static/media/mail-send.b8016746.svg";